import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import CreateAcuDeviceProvider from "./baseProviders/createAcuDeviceProvider"
import useContinueAcuDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueAcuDeviceDraft"

interface IContinueAcuDeviceVersionUrlParams {
    deviceRef: string
}

interface IContinueAcuDeviceVersionProviderProps {
    children: ReactNode
}

const ContinueAcuDeviceVersionProvider = ({
    children,
}: IContinueAcuDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueAcuDeviceVersionUrlParams
    >() as IContinueAcuDeviceVersionUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueVersionError,
        attachmentUUID,
    } = useContinueAcuDeviceDraft(urlDeviceRef)

    return (
        <CreateAcuDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueVersionError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={urlDeviceRef}
            canEditManufacturer={false}
        >
            {children}
        </CreateAcuDeviceProvider>
    )
}

export default ContinueAcuDeviceVersionProvider
